import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomFacturacionElctronica
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0001
 **/
class CustomFavoritosFacturacion extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.consultarFavoritos = this.consultarFavoritos.bind(this);
        this.setCampos = this.setCampos.bind(this);
        this.succesPedidosConItems = this.succesPedidosConItems.bind(this);
        this.gridOptionsPedidosFav = Object.assign({}, this.gridOptions);
        this.succesContarEliminados = this.succesContarEliminados.bind(this);
        this.succesInfoEliminadosConItems = this.succesInfoEliminadosConItems.bind(this); 
        this.guardarFavoritos = this.guardarFavoritos.bind(this);
        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo     = this.formatNumberSaldo.bind(this);
        this.changeKeyUpCustom     = this.changeKeyUpCustom.bind(this);
    }

    initForm() {
        console.log('Formulario CustomFavoritosFacturacion,  @version: jdesk_1.01.0009.3, @author:Patricia López Sánchez, fecha:2025/06/04')

        this.getField('numero_pedido').setOnChange(this.limpiarCampos);
        this.getField('numero_pedido').setKeyUp((e)=>{this.changeKeyUpCustom(e)});
        this.getField('consultar').setClick(this.consultarFavoritos);
        this.getField('guardar').setClick(this.guardarFavoritos);
    }
    
    changeKeyUpCustom = (e) =>{
        let keycode = (e.keyCode ? e.keyCode : e.which);
        //keycode 13 = enter_servicio;
        if(keycode === 13){
            this.consultarFavoritos();
            this.getField("numero_pedido").input.blur();
        }
    }

    consultarFavoritos(){
        if (this.getField('numero_pedido').valid()) {
            this.getField('consultar').setDisabled(true);
            let datos={ datos: {
                numero_pedido:this.getField('numero_pedido').getValue()
            }};
    
            this.generalFormatPmv = { tipo_servicio: 'fact-favoritos', operacion: 'contar', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.setCampos,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
        }
    }

    setCampos(data) {
        if (data.estado_p === 200) {
            if (data.data[0].cabecera === 1) {

                this.getField('tipo').setValue(1);

                let datos={ datos: {
                    numero_pedido: this.getField('numero_pedido').getValue()
                }};

                this.generalFormatPmv = { tipo_servicio: 'fact-favoritos', operacion: 'informacionpedidosconitems', operacion_tipo: 'consulta' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'GET',
                        body: datos,
                        success: this.succesPedidosConItems,
                        error: this.error_,
                        general: this.generalFormatPmv,
                    }); 
            }
        } else {
            if (data.estado_p === 404) {
                let datos={ datos: {
                    numero_pedido: this.getField('numero_pedido').getValue()
                }}
         
                this.generalFormatPmv = { tipo_servicio: 'fact-favoritos', operacion: 'contareliminados', operacion_tipo: 'consulta' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'GET',
                        body: datos,
                        success: this.succesContarEliminados,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage:false
                    }); 
            } else {
                if(data.estado_p === 500){
                    this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");
                } else if(data.estado_p === 502) {
                    this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");
                }
            }

        }
    }

    succesPedidosConItems(data) {

        if (data.estado_p === 200) {
            this.getField('mensaje').setVisible(true);
            this.getField('valor_total').setVisible(true);
            this.getField('nit').setVisible(true);
            this.getField('sede').setVisible(true);
            this.getField('ncliente').setVisible(true);
            this.getField('guardar').setVisible(true);
            this.getField('nit').setValue(data.data[0].pedido.nit);
            this.getField('sede').setValue(data.data[0].pedido.sede);
            this.getField('ncliente').setValue(data.data[0].pedido.nombre);
            if (data.data[0].pedido.recalcula_precio === null || data.data[0].pedido.recalcula_precio === '') {
                this.getField('recalcula_precio').setValue('S');
            }else if (data.data[0].pedido.recalcula_precio !== null && data.data[0].pedido.recalcula_precio !== ''){
                this.getField('recalcula_precio').setValue(data.data[0].pedido.recalcula_precio);
            }
            let configCell = new Map();
            configCell.set('precio_mas_iva', {width: 161, cellRenderer: (props) => {return ""+this.currencyFormatterGeneral(props.data.precio_mas_iva.toFixed(2)) } , type: 'rightAligned' });
            configCell.set('precio_total', {width: 144, cellRenderer: (props) => {return ""+this.currencyFormatterGeneral(props.data.precio_total.toFixed(2)); }, type: 'rightAligned'  });
            configCell.set('tarifa_iva', {width: 144, type: 'rightAligned'  });
            this.gridOptionsPedidosFav['rowData'] = [];
            this.getField('tb_pedidos').toggle(true);
            this.gridOptionsPedidosFav['rowData'] = data.data[0].items;
            this.getField('tb_pedidos').initData(this.gridOptionsPedidosFav, configCell);
    
            let cantidadxprecioMasIva = 0;
            let totalValor = 0;
    
    
            data.data[0].items.forEach(function (numero) {
                cantidadxprecioMasIva = (numero.cantidad * numero.precio_mas_iva);
                totalValor += cantidadxprecioMasIva;
            });
    
            this.getField('valor_total').setValue(totalValor.toFixed(2));
        }else{
            this.getField('consultar').setDisabled(false);
            if(data.estado_p === 404) {
                this.getField('fieldAlert').toggle(true, "El pedido no existe", "error");
                this.getField('nit').setValue('');
                this.getField('sede').setValue('');
                this.getField('ncliente').setValue('');
                this.getField('tb_pedidos').toggle(false);
                this.getField('numero_pedido').input.focus();
            } else {
                if(data.estado_p === 500){
                    this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");

                } else if(data.estado_p === 502) {
                    this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");
                }
            }
        }

    }

    succesContarEliminados(data) {
        if (data.estado_p === 200) {
            if (data.data[0].cabecera === 1) {

                this.getField('tipo').setValue(2);

                let datos={ datos: {
                   numero_pedido: this.getField('numero_pedido').getValue()
                }}

                this.generalFormatPmv = { tipo_servicio: 'fact-favoritos', operacion: 'informacionpedidoseliminadosconitems', operacion_tipo: 'modificar' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'GET',
                        body: datos,
                        success: this.succesInfoEliminadosConItems,
                        error: this.error_,
                        general: this.generalFormatPmv,
                    }); 
            } 
        } else { 
            this.getField('consultar').setDisabled(false);
            if(data.estado_p === 404) {
                this.getField('fieldAlert').toggle(true, "El pedido no existe", "error");
                this.getField('nit').setValue('');
                this.getField('sede').setValue('');
                this.getField('ncliente').setValue('');
                this.getField('tb_pedidos').toggle(false);
                this.getField('numero_pedido').input.focus();// Se hace; ya que si el pedido no existe, haga focus en el campo "Número de pedido"
            } else {
                if(data.estado_p === 500){
                    this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");

                } else if(data.estado_p === 502) {
                    this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");
                }
            }
        } 
    }

    

    succesInfoEliminadosConItems(data) {
        if (data.estado_p === 200) {
            this.getField('mensaje').setVisible(true);
            this.getField('valor_total').setVisible(true);
            this.getField('nit').setVisible(true);
            this.getField('sede').setVisible(true);
            this.getField('ncliente').setVisible(true);
            this.getField('guardar').setVisible(true);
            this.getField('nit').setValue(data.data[0].pedido.nit);
            this.getField('sede').setValue(data.data[0].pedido.sede);
            this.getField('ncliente').setValue(data.data[0].pedido.nombre);
            if (data.data[0].pedido.recalcula_precio === null || data.data[0].pedido.recalcula_precio === '') {
                this.getField('recalcula_precio').setValue('S');
            }else if (data.data[0].pedido.recalcula_precio !== null && data.data[0].pedido.recalcula_precio !== ''){
                this.getField('recalcula_precio').setValue(data.data[0].pedido.recalcula_precio);
            }
            let configCell = new Map();
            configCell.set('precio_mas_iva', {width: 161, cellRenderer: (props) => {return ""+this.currencyFormatterGeneral(props.data.precio_mas_iva.toFixed(2)) } , type: 'rightAligned' });
            configCell.set('precio_total', {width: 144, cellRenderer: (props) => {return ""+this.currencyFormatterGeneral(props.data.precio_total.toFixed(2)); }, type: 'rightAligned'  });
            configCell.set('tarifa_iva', {width: 144, type: 'rightAligned'  });
            this.gridOptionsPedidosFav['rowData'] = [];
            this.getField('tb_pedidos').toggle(true);
            this.gridOptionsPedidosFav['rowData'] = data.data[0].items;
            this.getField('tb_pedidos').initData(this.gridOptionsPedidosFav, configCell);
    
            let cantidadxprecioMasIva = 0;
            let totalValor = 0;
        
            data.data[0].items.forEach(function (numero) {
                cantidadxprecioMasIva = (numero.cantidad * numero.precio_mas_iva);
                totalValor += cantidadxprecioMasIva;
            });
    
            this.getField('valor_total').setValue(totalValor.toFixed(2));
        }
    }
    
    guardarFavoritos() {
        if (this.getField('mensaje').getValue() !== '' && this.getField('mensaje').getValue() !== ' ' && this.getField('mensaje').valid()) {
            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
            this.getField('confirmModalCustom').setClickDialog(()=>{/*Se hace este setClickDialog para especificar que el click en este confirmModalCustom no hace nada, no tiene ninguna acción*/});
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
            let datos={ datos: {
                numero_pedido: this.getField('numero_pedido').getValue(),
                tipo: parseInt(this.getField('tipo').getValue()),
                mensaje: this.getField('mensaje').getValue(),
                recalcula_precio: this.getField('recalcula_precio').getValue()
            }};
            
            this.generalFormatPmv = { tipo_servicio: 'fact-favoritos', operacion: 'favoritos', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.limpiarCampos,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                }); 
         } else {
            this.getField('mensaje').setError(true, 'Este campo es requerido');
        }
    }

    limpiarCampos(data) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('mensaje').setValue('');
        this.getField('valor_total').setValue('');
        this.getField('nit').setValue('');
        this.getField('sede').setValue('');
        this.getField('ncliente').setValue('');
        this.getField('tipo').setValue('');
        this.getField('tb_pedidos').toggle(false);
        this.getField('mensaje').setVisible(false);
        this.getField('valor_total').setVisible(false);
        this.getField('nit').setVisible(false);
        this.getField('sede').setVisible(false);
        this.getField('ncliente').setVisible(false);
        this.getField('tipo').setVisible(false);
        this.getField('guardar').setVisible(false);
        this.getField('tb_pedidos').toggle(false);
        this.getField('consultar').setDisabled(false);
        if(data.estado_p === 200){
            this.getField('fieldAlert').toggle(true,data.data[0].mensaje,"success");
        } else if(data.estado_p === 502 && data.data.errores){
            let arrayErrores = [];
            arrayErrores = Object.keys(data.data.errores);
            let mensajeError = '';
            for (let i = 0; i < arrayErrores.length; i++) {
                mensajeError += `El campo "${arrayErrores[i]}" es requerido, `;
            }
            this.getField('fieldAlert').toggle(true, mensajeError,"error");
        } else if(data.estado_p === 404){
            this.getField('fieldAlert').toggle(true,data.data.mensaje,"error");
        } 
    }
    
    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }
}

FormJaivana.addController("fact-favoritos", CustomFavoritosFacturacion);
export default CustomFavoritosFacturacion;